import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


export default new Vuex.Store({
  state: {

    // Current Instance
    isDevMode: window.utmbWeb.isDevMode,
    isInternal: window.utmbWeb.isInternal,
    isIntranet: window.utmbWeb.isIntranet,

    // App / Site Details
    siteId: window.utmbWeb.siteId,
    siteRoot: window.utmbWeb.siteRoot,
    siteTitle: window.utmbWeb.siteTitle,
    headerTitle: window.utmbWeb.headerTitle,
    headerSubtitle: window.utmbWeb.headerSubtitle,

    // Page / Sitefinity Template
    pageTitle: window.utmbWeb.pageTitle,
    pageUrl: window.utmbWeb.pageUrl,
    pageUrlName: window.utmbWeb.pageUrlName,
    pageNodeKey: window.utmbWeb.pageNodeKey,
    pageId: window.utmbWeb.pageId,
    pageTemplateId: window.utmbWeb.pageTemplateId,
    pageTemplateTitle: window.utmbWeb.pageTemplateTitle,
    pageIsDesignMode: window.utmbWeb.pageIsDesignMode,
    pageIsPreviewMode: window.utmbWeb.pageIsPreviewMode,

    // Layout / Design
    designMode: window.utmbWeb.designMode,
    theme: window.utmbWeb.theme,
    pageWidth: window.utmbWeb.pageWidth,
    useArtboard: window.utmbWeb.useArtboard, // Classic Only
    usePadding: window.utmbWeb.useArticlePadding, // Classic Only
    usePagePreloader: window.utmbWeb.usePagePreloader,
    useConsoleLog: window.utmbWeb.useConsoleLog,
    siteCss: window.utmbWeb.siteSpecificCss,
    siteJs: window.utmbWeb.siteSpecificJs,

    // Vendors
    useVendorIconsFontAwesome: window.utmbWeb.useVendorIconsFontAwesome,
    useVendorIconsFoundation: window.utmbWeb.useVendorIconsFoundation,
    useVendorBootstrap: window.utmbWeb.useVendorBootstrap,
    useVendorJQuery: window.utmbWeb.useVendorJQuery,
    useVendorVueJs: window.utmbWeb.useVendorVueJs,

    // Mobile Menu
    useMobileMenu: window.utmbWeb.useMobileMenu,
    mobileMenuTheme: window.utmbWeb.mobileMenuTheme,

    // Explore Menu
    useExploreMenu: window.utmbWeb.useExploreMenu,
    exploreMenuTheme: window.utmbWeb.exploreMenuTheme, 
    exploreMenuSource: window.utmbWeb.exploreMenuSource,

    // Navigate Menu
    useNavigateMenu: window.utmbWeb.useNavigateMenu,
    navigateMenuTheme: window.utmbWeb.navigateMenuTheme,
    useNavigateMenuSitefinityApi: window.utmbWeb.useNavigateMenuSitefinityApi,
    navigateMenuUseAccordion: window.utmbWeb.navigateMenuUseAccordion,
    navigateMenuLevels: window.utmbWeb.navigateMenuLevels,

    // Search Menu
    useSearchMenu: window.utmbWeb.useSearchMenu,
    searchMenuTheme: window.utmbWeb.searchMenuTheme,
    searchSiteUrl: window.utmbWeb.searchSiteUrl,

    // Footer Login
    useFooter: window.utmbWeb.useFooter,
    useFooterSitefinityLogin: window.utmbWeb.useFooterSitefinityLogin,
    useProdLoginUrls: window.utmbWeb.useProdLoginUrls,

    // Breadcrumbs
    useBreadcrumbs: window.utmbWeb.useBreadcrumbs,

    // Site Ownership (Kudos)
    kudos1: window.utmbWeb.kudos1,
    kudos1Url: window.utmbWeb.kudos1Url,
    kudos2: window.utmbWeb.kudos2,
    kudos2Url: window.utmbWeb.kudos2Url,
    kudos3: window.utmbWeb.kudos3,
    kudos3Url: window.utmbWeb.kudos3Url,

    // Root Domain
    rootDomainTitle: window.utmbWeb.rootDomainTitle,
    rootDomainUrl: window.utmbWeb.rootDomainUrl,

    // Institutional Resources
    useUtmbAlertSystem: window.utmbWeb.useUtmbAlertSystem,
    useUtmbAnalytics: window.utmbWeb.useUtmbAnalytics,

    // Content Placeholder Regions (in Master)
    useRegion_topbarContent: window.utmbWeb.useRegion_topbarContent,
    useRegion_atopContent: window.utmbWeb.useRegion_atopContent,
    useRegion_featureContent: window.utmbWeb.useRegion_articleContent,
    useRegion_articleContent: window.utmbWeb.useRegion_articleContent,
    useRegion_baseContent: window.utmbWeb.useRegion_baseContent,
    useRegion_subContent: window.utmbWeb.useRegion_subContent,
  },
  mutations: {

  },
  actions: {

  }
})
